(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-slider"] && !Shopify.designMode) return;
  try {
    
  class ArticleSlider extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        $slider: this.querySelector('.article-slider__slider'),
      };
      this.$slider = null;
    }

    connectedCallback() {
      this.$slider = $(this.elements.$slider).slick({
        dots: this.getAttribute('data-enable-dots') == 'true',
        arrows: this.getAttribute('data-enable-arrows') == 'true',
        // slidesToShow: parseFloat(this.dataset.slidesToShow),
        mobileFirst: true,
        slidesToShow: 1.33,
        infinite: false,
        nextArrow:
          '<span class="slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  }

  if (customElements.get('article-slider') === undefined) {
    customElements.define('article-slider', ArticleSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-nav"] && !Shopify.designMode) return;
  try {
    
  class BlogNav extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        dropdownItems: this.querySelectorAll('[data-has-submenu]'),
        mobileToggle: this.querySelector('.blog-nav__mobile-toggle'),
        navMenu: this.querySelector('[data-nav-menu]'),
      };
      this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    }

    connectedCallback() {
      if (this.elements.mobileToggle && this.elements.navMenu) {
        const setMenuState = () => {
          if (this.isMobile) {
            this.closeNav();
            this.elements.mobileToggle.hidden = false;
            // Open all submenus
            this.elements.dropdownItems.forEach((el) => {
              const toggle = el.querySelector('.blog-nav__link--toggle');
              const menu = el.querySelector('.blog-nav__submenu');
              this.openMenu(toggle, menu);
            });
          } else {
            this.openNav();
            this.elements.mobileToggle.hidden = true;
          }
        };

        this.elements.mobileToggle.addEventListener('click', () => {
          const isExpanded = this.elements.mobileToggle.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            this.closeNav();
          } else {
            this.openNav();
          }
        });

        window.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.closeNav();
          }
        });

        window.addEventListener('resize', setMenuState);
        setMenuState();
      }

      this.elements.dropdownItems.forEach((el) => {
        const toggle = el.querySelector('.blog-nav__link--toggle');
        const menu = el.querySelector('.blog-nav__submenu');
        const submenuItems = menu.querySelectorAll('.blog-nav__link');

        toggle.addEventListener('click', (e) => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          e.preventDefault();

          if (isExpanded) {
            this.closeMenu(toggle, menu);
          } else {
            this.openMenu(toggle, menu);
            // Focus first item
            const firstItem = submenuItems[0];
            if (firstItem) firstItem.focus();
          }
        });

        toggle.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
              this.closeMenu(toggle, menu);
            } else {
              this.openMenu(toggle, menu);
              const firstItem = submenuItems[0];
              if (firstItem) firstItem.focus();
            }
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (toggle.getAttribute('aria-expanded') !== 'true') {
              this.openMenu(toggle, menu);
            }
            const firstItem = submenuItems[0];
            if (firstItem) firstItem.focus();
          }
        });

        submenuItems.forEach((item, index) => {
          item.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              const nextItem = submenuItems[index + 1];
              if (nextItem) nextItem.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              if (index === 0) {
                toggle.focus();
              } else {
                const prevItem = submenuItems[index - 1];
                if (prevItem) prevItem.focus();
              }
            } else if (e.key === 'Escape') {
              this.closeMenu(toggle, menu);
              toggle.focus();
            }
          });
        });

        el.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeMenu(toggle, menu);
            toggle.focus();
          }
        });

        // Close when focus leaves the submenu
        el.addEventListener('focusout', (e) => {
          if (!el.contains(e.relatedTarget)) {
            this.closeMenu(toggle, menu);
          }
        });
      });
    }

    openMenu(trigger, menu) {
      trigger.setAttribute('aria-expanded', 'true');
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
    }

    closeMenu(trigger, menu) {
      trigger.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
    }

    openNav() {
      this.elements.navMenu.classList.add('is-open');
      this.elements.mobileToggle.classList.add('is-expanded');
      this.elements.navMenu.setAttribute('aria-hidden', 'false');
      this.elements.mobileToggle.setAttribute('aria-expanded', 'true');
    }

    closeNav() {
      this.elements.navMenu.classList.remove('is-open');
      this.elements.mobileToggle.classList.remove('is-expanded');
      this.elements.navMenu.setAttribute('aria-hidden', 'true');
      this.elements.mobileToggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!window.customElements.get('blog-nav')) {
    window.customElements.define('blog-nav', BlogNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          this.onChildElementsLoad();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    onChildElementsLoad() {
      this.runSlick();
    }

    runSlick() {
      const recommendationsId = this.querySelector('.cstmgrid').id;

      const $recommSlider = $(`#${recommendationsId}`).slick({
        infinite: false,
        slidesToShow: 3.38,
        dots: false,
        accessibility: true,
        arrows: true,
        nextArrow:
          '<span class="slick-next slick-arrow" role="button"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="slick-prev slick-arrow" role="button"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      });

      $(`#${recommendationsId}`).css('opacity', '1');
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.elements = {
        slider: this.querySelector('.featured-collection__slider'),
      };
      this.settings = {
        enableArrows: Boolean(this.dataset.enableArrows),
        enablePagination: Boolean(this.dataset.enablePagination),
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = $(this.elements.slider).slick({
        dots: true,
        infinite: false,
        slidesToShow: 1.25,
        nextArrow:
          '<span class="custom-slick-arrows slick-next slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="custom-slick-arrows slick-prev slick-arrow" ><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#000000}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  }

  if (window.customElements.get('featured-collection') === undefined) {
    window.customElements.define('featured-collection', FeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const footerAccButtons = document.querySelectorAll('.footer-menu__header-wrapper');

    footerAccButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        var panel = btn.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const mega_menu_overlay = document.querySelector('#mega-menu-overlay');
  const elements = document.querySelectorAll('header-menu');

  elements.forEach((element) => {
    element.addEventListener('mouseover', handleMouseOver);
    element.addEventListener('mouseout', handleMouseOut);
  });

  function handleMouseOver(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.setAttribute('open', '');
    mega_menu_overlay.style.display = 'block';
  }
  function handleMouseOut(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.removeAttribute('open', '');
    mega_menu_overlay.style.display = 'none';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-store-dealer-form"] && !Shopify.designMode) return;
  try {
    
  const elements = {
    form: document.querySelector('[data-store-dealer-form]'),
    dealerTagsInput: document.getElementById('DealerTags'),
    checkboxes: document.querySelectorAll('[data-store-dealer-checkboxes]'),
    submitButton: document.querySelector('[data-store-dealer-submit]'),
    alerts: document.querySelectorAll('[data-store-dealer-alert]'),
    alertsClose: document.querySelectorAll('[data-alert-close]'),
  };

  function onFormSubmit(evt) {
    evt.preventDefault();
    updateDealerTagsInput(); // Append tags to the hidden input field
    const formData = new FormData(evt.target);
    elements.submitButton.disabled = true;

    postForm(formData);
  }

  async function postForm(formData) {
    try {
      const response = await fetch(elements.form.getAttribute('action'), {
        method: 'POST',
        body: formData,
      });

      const text = await response.text();

      if (!response.ok) {
        throw new Error(`Error: ${response}`);
      }

      handleAlerts('success');
    } catch (error) {
      handleAlerts('error');
      console.error(error);
    } finally {
      resetForm();
      elements.submitButton.disabled = false;

      setTimeout(() => {
        handleAlerts('hidden');
      }, 5000);
    }
  }

  function setUpCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('DealerCountry', 'DealerProvince', {
        hideElement: 'DealerProvinceContainer',
      });
    }
  }

  function resetForm() {
    const inputs = elements.form.querySelectorAll('input');
    const selects = elements.form.querySelectorAll('select');

    inputs.forEach((el) => {
      el.value = '';
      if (el.checked) {
        el.checked = false;
      }
    });

    selects.forEach((el) => {
      el.selectedIndex = 0;
    });
  }

  function handleAlerts(status) {
    elements.alerts.forEach((el) =>
      el.dataset.status === status ? (el.style.display = 'block') : (el.style.display = 'none')
    );
  }

  function updateDealerTagsInput() {
    const tagsInput = elements.tags;
    let tagsValue = '';

    elements.checkboxes.forEach((el) => {
      if (el.checked) {
        const newValue = `${el.name};`;
        tagsValue = tagsValue + newValue;
      }
    });

    elements.dealerTagsInput.value = tagsValue;
  }

  function onLoad(params) {
    setUpCountries();

    // Bind Listeners
    elements.form.addEventListener('submit', onFormSubmit);
    elements.alertsClose.forEach((el) => {
      el.addEventListener('click', () => {
        handleAlerts('hidden');
      });
    });
  }

  onLoad();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductsSlider extends HTMLElement {
    constructor() {
      super();
      this.$slider = null;
      this.sliderConfig = {
        mobileFirst: true,
        dots: this.getAttribute('data-enable-dots') == 'true',
        arrows: this.getAttribute('data-enable-arrows') == 'true',
        slidesToShow: 1.35,
        infinite: false,
        nextArrow:
          '<span class="slick-next slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>',
        prevArrow:
          '<span class="slick-prev slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3.35,
            },
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4.5,
            },
          },
        ],
      };
    }

    connectedCallback() {
      this.$slider = $(this).find('.products-slider').slick(this.sliderConfig);
    }
  }

  if (window.customElements.get('products-slider') === undefined) {
    customElements.define('products-slider', ProductsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
